"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29.9 13.88C26.67 8.49 21.22 5 16 5S5.33 8.49 2.1 13.88L.84 16l1.26 2.12C5.33 23.51 10.79 27 16 27s10.67-3.49 13.9-8.88L31.17 16zm-1.72 3.21C25.31 21.9 20.53 25 16 25s-9.31-3.1-12.18-7.91L3.17 16l.65-1.09C6.69 10.1 11.47 7 16 7s9.31 3.1 12.18 7.91l.65 1.09z" }),
        React.createElement("path", { d: "M16 10a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z" })));
}
exports.default = SvgEyeOutline;
//# sourceMappingURL=EyeOutline.js.map